import { Get, Post } from '../requestBuilder/buildFetchRequest';
import { EmployeeSettings, EmployeeSettingsWithServerSetting } from './EmployeeSettings';
import SystemSettings from './SystemSettings';
import UpdateSystemSettings from './UpdateSystemSettings';
import UpdateEmployeeSettings from './UpdateEmployeeSettings';

// eslint-disable-next-line import/prefer-default-export
export const getSystemSettings = (): Promise<SystemSettings> => (
  Get('/api/systemSettings')
    .Execute()
);

export const updateSystemSettings = (settings: UpdateSystemSettings) => (
  Post('/api/systemSettings')
    .AddBody(settings)
    .Execute<void>()
);

export const getEmployeeSettings = (): Promise<EmployeeSettings> => (
  Get('/api/employeeSettings')
    .AddQueryParams({ includeSystemSettings: false })
    .Execute()
);

export const getEmployeeSettingsWithServerSettings = (): Promise<EmployeeSettingsWithServerSetting> => (
  Get('/api/employeeSettings')
    .AddQueryParams({ includeSystemSettings: true })
    .Execute()
);

export const updateEmployeeSettings = (settings: UpdateEmployeeSettings) => (
  Post('/api/employeeSettings')
    .AddBody(settings)
    .Execute<void>()
);
